import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// ── 樣式載入順序（重要）─────────────────────────────────────────────────────
// theme(design tokens) → 全域 → reactflow 原生 → reactflow 覆寫
// 順序決定 CSS specificity；最後引入的覆寫檔才能蓋過 reactflow 預設樣式。
// 改網站主體顏色 / 字體 / 圓角 / 陰影 → 改 `src/styles/theme.css` 一個檔即可。
import '@/styles/theme.css';
import '@/styles/global.css';
import 'reactflow/dist/style.css';
import '@/styles/reactflow-overrides.css';

// i18n 初始化（side-effect import，執行即掛載到預設 instance）
// R413 — en / ja 字典改成用到才載入;`i18nReady` = 偵測到的語言字典已就緒(永不 reject)。
import { i18nReady } from '@/i18n';

import { App } from '@/app/App';
// R218 深色模式:在 `<html>` 掛 data-theme(預設跟隨系統,`hai.theme` 可覆蓋)
import { initThemeMode } from '@/styles/themeMode';
// R249 回報系統:把未處理錯誤 / rejection 收進診斷緩衝(在 render 之前掛,才接得到
// boot 期間的錯誤 —— config 缺值、i18n 載入失敗那一類正是最需要記的)
import { installConsoleTrail } from '@/lib/diagnostics/consoleTrail';

/**
 * 應用程式進入點
 * 直接對應 `index.html` 中的 `<div id="root">`。
 */

// R218 — 主題必須在第一次 render **之前**同步決定(晚了會先閃一下淺色再翻黑)。
// 預設 `system` 跟隨 `prefers-color-scheme` 並掛 mq listener(OS 切換免重整);
// `localStorage['hai.theme'] = 'dark'|'light'` 明確覆蓋。細節見 themeMode.ts 檔頭。
initThemeMode();
installConsoleTrail();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('mount node <div id="root"> not found in index.html');

// R413 — 等語言字典就緒才第一次 render:en / ja 使用者不會先閃一下繁中再翻過去。
// zh-TW(預設)是靜態字典,init 一完成就 resolve,等於沒有等待。
void i18nReady.then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
